import { validateOnboarding } from '@/services/onboarding.services'
import { ROUTES } from '../constants/routes'

export async function onboardingRedirect(
  redirectFallback: string = ROUTES.HOME,
) {
  if (redirectFallback.startsWith(ROUTES.TELEVET)) {
    return redirectFallback
  }

  try {
    const obValidation = await validateOnboarding()

    if (obValidation.pet.showOnboarding) {
      return ROUTES.ONBOARDING_PET
    }

    if (obValidation.renters.showOnboarding) {
      return ROUTES.ONBOARDING_RENTERS
    }

    return redirectFallback
  } catch (e) {
    console.error('Error fetching onboarding validation', e)
    return redirectFallback
  }
}
